import { lazy } from "react";

import type { NavigationRoutingObject } from "@navigationRouting/types";

import type { I18nT } from "@lib/dashboardI18n";

const SurveysHub = lazy(() =>
  import("@scenes/Surveys/SurveysHub").then((module) => ({
    default: module.SurveysHub,
  }))
);

export const surveysHubNRO: NavigationRoutingObject = {
  Component: SurveysHub,
  componentFeatureFlippers: [],
  noKnockoutFallback: true,
  section: "messaging",
  heading: (t: I18nT<"dashboard-navigation">) => t("surveys-sidebar-pill-menu-option", "Surveys"),
  pageNameForTracking: () => "Surveys Hub",
  description: (t: I18nT<"dashboard-navigation">) =>
    t(
      "surveys-sidebar-pill-menu-option-description",
      "Create and manage customer surveys to gather valuable feedback and insights"
    ),
  icon: "nav-system-reports",
  tag: "new",
  getDeveloperNavigationAllowed: ({ featureOn }) => {
    return (
      featureOn("surveys_hub") &&
      (featureOn("landing_page_surveys") || featureOn("iam_surveys") || featureOn("banner_surveys"))
    );
  },
  additionalSearchTerms: () => [],
  additionalSearchableFeatures: () => ({}),
  defaultRoute: "/engagement/surveys/:appGroupId",
};
